import * as React from "react";
import { Lightbox } from "../../../../../../react-core/Html/Components/Lightbox";
import { Alert } from "../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { DashboardFilterStore, NotificationFilterStore } from "../../Store/Variable";
import { ClientDashboardFiltersModel } from "../../../../../../Wrap/Models/Domains/Users/DashboardFilter/ClientDashboardFiltersModel";
import { DateRangeOptionType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/DateRangeOptionType";
import { CompanySummary } from "../../../../../../Wrap/Models/Models/Company/CompanySummary";
import { NetworkHistoryModel } from "../../../../../../Wrap/Models/Models/Network/NetworkHistoryModel";
import { Adviser } from "../../../../../../Wrap/Models/Domains/Adviser/Adviser";
import { DashboardFilterForm } from "../Workflow/DashboardFilterForm";
import { DashboardTab, OpreationType } from "../../Resource/Content";
import { ClientNotificationFiltersModel } from "../../../../../../Wrap/Models/Domains/Users/NotificationFilter/ClientNotificationFiltersModel";
import { NotificationFilterForm } from "../Notification/NotificationFilterForm";

interface IDashBoardFilterEditorProps {
    onSave?: (data) => void;
    onAdd?: (data) => void;
    onCancel: VoidFunction;
    onDelete: (filterId: number) => void;
    setDeletelightbox?: (value: boolean) => void;
    FilterId?: number;
    dashBoardFilterCount?: number;
    currentTabIndex: DashboardTab;
}

interface IDashBoardFilterEditorState {
    data?: ClientDashboardFiltersModel | ClientNotificationFiltersModel;
    showErrorMsg: boolean;
    errorMessage?: string;
}

export class DashboardFilterLightbox extends FormComponent<IDashBoardFilterEditorProps, IDashBoardFilterEditorState> {
    constructor(props: IDashBoardFilterEditorProps) {
        super(props);
        this.state = {
            data:
                props.currentTabIndex == DashboardTab.Workflow
                    ? DashboardFilterStore.getFilterItemById(props.FilterId)
                    : NotificationFilterStore.getFilterItemById(props.FilterId),
            showErrorMsg: false,
            errorMessage: "",
        };
    }

    private isEdit = !CommonHelper.isNullOrEmpty(this.props.FilterId);

    private onDataChange = (operation: OpreationType, data: any, dashBoardFilterCount?: number) => {
        if (this.state.data?.FilterName === "") {
            this.setState({ showErrorMsg: true, errorMessage: "Filter name can't be null" });
            return;
        }
        if (operation === OpreationType.Add) {
            if (this.props.dashBoardFilterCount >= 15) {
                this.setState({ showErrorMsg: true, errorMessage: "Total filters cannot exceed 15" });
                return;
            }

            this.props.onAdd(data);
        } else if (operation === OpreationType.Save) {
            this.props.onSave(data);
        } else if (operation === OpreationType.Delete) {
            if (dashBoardFilterCount <= 1) {
                this.setState({ showErrorMsg: true, errorMessage: "Must have at least 1 filter" });
                return;
            }
            this.props.onDelete(data.FilterId);
        }
        this.props.onCancel();
    };

    private form = null;

    render() {
        const { data } = this.state;

        return (
            <>
                <Lightbox
                    cssWrapper={`is-default-lightbox ${
                        this.props.currentTabIndex == DashboardTab.Workflow ? "is-narrow" : "is-wide"
                    }`}
                    onClose={() => this.props.onCancel()}
                    show={true}
                    isClickOutsideClose={false}
                    title={
                        this.isEdit
                            ? `Edit ${this.props.currentTabIndex.toLowerCase()} filter`
                            : `Create ${this.props.currentTabIndex.toLowerCase()} filter`
                    }
                >
                    <>
                        {this.props.currentTabIndex == DashboardTab.Workflow && (
                            <DashboardFilterForm
                                data={data as ClientDashboardFiltersModel}
                                onRef={(v) => (this.form = v)}
                                isLightbox
                                isActivity={false}
                            />
                        )}
                        {this.props.currentTabIndex == DashboardTab.Notification && (
                            <NotificationFilterForm
                                currentFilter={data as ClientNotificationFiltersModel}
                                onRef={(v) => (this.form = v)}
                                isLightbox
                            />
                        )}
                        {this.state.showErrorMsg && (
                            <Alert alertType={AlertType.Error} message={this.state.errorMessage} />
                        )}
                        <div className="row row-right mini-gutter mt-20">
                            {this.isEdit && (
                                <div className="col-fluid col-middle">
                                    <button
                                        className="remove-button icon-left"
                                        disabled={false}
                                        onClick={() => {
                                            if (this.props.dashBoardFilterCount <= 1) {
                                                this.setState({
                                                    showErrorMsg: true,
                                                    errorMessage: "Filter can't be less than 1",
                                                });
                                                return;
                                            }
                                            this.props.setDeletelightbox(true);
                                        }}
                                    >
                                        <span className="icon" aria-hidden="true"></span>
                                        <span className="text text-size-16">Delete filter</span>
                                    </button>
                                </div>
                            )}
                            <div className="col-auto">
                                <button
                                    className="btn secondary mr-12"
                                    onClick={() => {
                                        this.props.onCancel();
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                            <div className="col-auto">
                                <button
                                    className="btn primary"
                                    onClick={() => {
                                        if (!this.isValid() || !this.form.isValid()) {return;}
                                        const _data = { ...this.form.getData() };
                                        if (this.isEdit) {
                                            this.onDataChange(OpreationType.Save, _data);
                                        } else {
                                            this.onDataChange(OpreationType.Add, _data);
                                        }
                                    }}
                                >
                                    {"Save"}
                                </button>
                            </div>
                        </div>
                    </>
                </Lightbox>
            </>
        );
    }
}
